import styled from 'styled-components'

import { WhiteBlock } from 'components/Layout'
import { Font16, H1 } from 'components/Typography'
import theme from 'theme_'

export const NotFoundBlockWrapper = styled(WhiteBlock)`
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 60vh;
`

export const NotFoundTitle = styled(H1)`
  margin: ${theme.spacing.sm} 0 ${theme.spacing.base};
  color: ${theme.colors.duneWarmGrey};
  text-align: center;
`

export const NotFoundText = styled.div`
  ${Font16}
  color: ${theme.colors.duneWarmGrey};
`
